import { useEffect } from "react";

export function FocusManager() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    let keyboardMode = false;

    const handleKeyDown = (e: KeyboardEvent) => {
      const keyboardKeys = [
        "Tab",
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
        "Enter",
        "Space",
        "Escape",
        "Home",
        "End",
      ];

      if (keyboardKeys.includes(e.key)) {
        keyboardMode = true;
        document.body.classList.add("user-is-tabbing");
      }
    };

    const handlePointer = () => {
      keyboardMode = false;
      document.body.classList.remove("user-is-tabbing");
    };

    const handleFocusIn = () => {
      if (keyboardMode) {
        document.body.classList.add("user-is-tabbing");
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);
    window.addEventListener("mousedown", handlePointer, true);
    window.addEventListener("touchstart", handlePointer, true);
    window.addEventListener("pointerdown", handlePointer, true);
    window.addEventListener("focusin", handleFocusIn, true);

    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
      window.removeEventListener("mousedown", handlePointer, true);
      window.removeEventListener("touchstart", handlePointer, true);
      window.removeEventListener("pointerdown", handlePointer, true);
      window.removeEventListener("focusin", handleFocusIn, true);
    };
  }, []);

  return null;
}
